import SignService from '../services/apiRequests/sign.service';

export default {
    namespaced: true,
    state: {
        stylus_response: null,
        sign_response: null,
        qr_response: null,
        qr_check_response: null
    },
    getters: {},
    mutations: {
        setStylusResponse(state, stylus_response) {
            state.stylus_response = stylus_response;
        },
        setSignResponse(state, sign_response) {
            state.sign_response = sign_response;
        },
        setQRResponse(state, qr_response) {
            state.qr_response = qr_response;
        },
        setQRCheckResponse(state, qr_check_response) {
            state.qr_check_response = qr_check_response;
        }
    },
    actions: {
        async postStylusSign({ commit }, { guid, sign_data, is_engineer }) {
            commit('setStylusResponse', null);
            let response = await SignService.postStylusSign(guid, sign_data, is_engineer);
            commit('setStylusResponse', response);
        },
        async postSign({ commit }, { guid, sign_data, is_engineer, is_qr }) {
            commit('setSignResponse', null);
            let response = await SignService.postSign(guid, sign_data, is_engineer, is_qr);
            commit('setSignResponse', response);
        },
        async requestToSign({ commit }, payload) {
            commit('setQRResponse', null);
            let response = await SignService.requestToSign(payload);
            commit('setQRResponse', response);
            return response;
        },
        async checkSign({ commit }, guid) {
            commit('setQRCheckResponse', null);
            let response = await SignService.checkSign(guid);
            commit('setQRCheckResponse', response);
        }
    }
};
